import * as React from 'react';

import { BookingFormState } from '../../../types/booking';

import { DefaultTranslations } from '~/modules/trade/i18n/useTranslations';

export const useValidateBookingInfoStep = () => {
  const validateBookingInfoStep = React.useCallback(
    (
      formData: BookingFormState,
      isDraft = false,
      t?: DefaultTranslations,
    ): Record<string, string> => {
      const errors: Record<string, string> = {};

      if (!formData.facilityId?.trim()) {
        errors.facilityId = t
          ? t.bookingsView.form.fields.facility + ' is required'
          : 'Facility is required';
      }

      if (!formData.bookingNumber?.trim()) {
        errors.bookingNumber = t
          ? t.bookingsView.form.fields.bookingNumber + ' is required'
          : 'Booking number is required';
      }

      // Required for non-draft bookings
      if (!isDraft) {
        if (!formData.vesselName?.trim()) {
          errors.vesselName = t
            ? t.bookingsView.form.fields.vesselName + ' is required'
            : 'Vessel name is required';
        }

        if (!formData.steamshipLine?.trim()) {
          errors.steamshipLine = t
            ? t.bookingsView.form.fields.steamshipLine + ' is required'
            : 'Steamship line is required';
        }

        if (!formData.loadingPortId?.trim()) {
          errors.loadingPort = t
            ? t.bookingsView.form.fields.loadingPort + ' is required'
            : 'Port of loading is required';
        }

        if (!formData.destinationPortId?.trim()) {
          errors.destinationPort = t
            ? t.bookingsView.form.fields.destinationPort + ' is required'
            : 'Port of destination is required';
        }

        // if (!formData.containers || formData.containers.length === 0) {
        //   errors.containers = t
        //     ? t.bookingsView.form.fields.containerType + ' is required'
        //     : 'At least one container is required';
        // } else {
        //   // Validate each container
        //   formData.containers.forEach((container, index) => {
        //     if (!container.quantity || container.quantity <= 0) {
        //       errors[`container_${index}_quantity`] = t
        //         ? t.bookingsView.form.fields.containersAmount +
        //           ' must be greater than 0'
        //         : 'Container quantity must be greater than 0';
        //     }
        //   });
        // }
      }

      return errors;
    },
    [],
  );

  return {
    validateBookingInfoStep,
  };
};
